import React, { useEffect, useState } from 'react'
import { Text, toast } from 'react-common'
import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router-dom'
import { Button } from '@platform/ui'
import classNames from 'classnames'
import { LEARN_EMAIL_ANSWER_SLUG } from '@/features/layout/LayoutMain/constants'
import { useSetActiveSlug } from '@/features/stencil/stubs'
import ImageCorrect from './assets/correct.svg'
import ImageIncorrect from './assets/incorrect.svg'
import styles from './KMEmailResponse.module.scss'
import { CourseRedirectByActivityId } from '../courses/CourseRedirectByActivityId/CourseRedirectByActivityId'

// TODO: Implement BE
export const KMEmailResponse: React.FC = () => {
  const [redirect, setRedirect] = useState(false)
  const [isCorrect, setIsCorrect] = useState<boolean | null>(null)

  useSetActiveSlug(LEARN_EMAIL_ANSWER_SLUG)

  const { t } = useTranslation()

  const { search } = useLocation()
  const params = new URLSearchParams(search)

  const activityId = params.get('activityId')
  const activityPathId = params.get('activityPathId')
  const answerId = params.get('answerId')
  const answerText = params.get('answerText')

  console.log('activityId:', activityId)
  console.log('activityPathId:', activityPathId)
  console.log('answerId:', answerId)
  console.log('answerText:', answerText)

  const title = isCorrect
    ? t('KMEmailResponse.correctWithAnswer', { answer: 'MY ANSWER' })
    : t('KMEmailResponse.incorrectWithAnswer', { answer: 'MY ANSWER' })

  const textRevisit = isCorrect ? t('KMEmailResponse.revisitCorrect') : t('KMEmailResponse.revisitIncorrect')

  const imgSrc = isCorrect ? ImageCorrect : ImageIncorrect
  const imgAlt = isCorrect ? t('KMEmailResponse.icon.correct') : t('KMEmailResponse.icon.incorrect')

  const handleReviewModuleClick = () => setRedirect(true)

  const onReviewModuleError = () => toast.critical(t('KMEmailResponse.moduleNotFound'))

  const setRandomIsCorrect = () => {
    setIsCorrect(Math.random() < 0.5)
  }

  useEffect(() => {
    setRandomIsCorrect()
  }, [])

  return (
    <div className={styles.wrapper}>
      <img src={imgSrc} alt={imgAlt} />

      <div>
        <Text.H3 className={styles.title}>{title}</Text.H3>

        <Text.Body2Medium className={styles.weightNormal}>
          This is generated by KM: Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque eget ex luctus,
          scelerisque lacus vel, venenatis enim. Nunc purus lectus, aliquet non arcu nec, pretium tempor leo. Donec
          mattis aliquet venenatis. Ut vel congue augue. Donec luctus faucibus nunc, rutrum commodo risus luctus at.
          Proin vitae feugiat mauris. Nam id elementum nisl.
        </Text.Body2Medium>

        <Text.Body2Medium className={classNames([styles.weightNormal, styles.textRevisit])}>
          {textRevisit}
        </Text.Body2Medium>
      </div>

      <Button
        text={t('KMEmailResponse.reviewModule')}
        size="small"
        style={{ padding: '5px 16px' }}
        onClick={handleReviewModuleClick}
      />

      {redirect && <CourseRedirectByActivityId onError={onReviewModuleError} />}
    </div>
  )
}
